export const liveParkingAvailabilitiesSelector = ({liveParkingAvailabilities}) => liveParkingAvailabilities